import {Popover} from "antd";
import {ReactNode, useEffect} from "react";
import {Heartbeat} from "@/utils/stateApiType";
import {hasConsecutiveZeros, StateItemText, UtxTime} from "@/utils/stateChange";

export default function StateItem({
                                      name, icon, statusList, colorStyle = {
        background: '#D49C5E9F',
        borderColor: '#D49C5E20'
    }
                                  }: {
    name: string,
    icon: ReactNode,
    statusList: Heartbeat[],
    colorStyle?: {
        background: string,
        borderColor: string
    }
}) {


    function modifyString(str: string): string {
        let uppercaseCount = 0;
        let result = '';
        const isAllUppercase = str === str.toUpperCase();

        for (let i = 0; i < str.length; i++) {
            if (str[i] === str[i].toUpperCase() && str[i] !== str[i].toLowerCase()) {
                uppercaseCount++;

                if (!isAllUppercase && uppercaseCount === 2) {
                    result += '-' + str[i].toLowerCase();
                    continue;
                }
            }
            if (str[i] === ' ') {
                result += '-';
            } else {
                result += str[i];
            }
        }

        if (isAllUppercase) {
            return result.replace(/ /g, '-').toLowerCase();
        }

        return result;
    }

    const hoursChange = (num: number) => {

        if (statusList.length) {
            let timestamp = statusList[Math.floor(statusList.length / num) - 1].time;
            if (statusList.length === 60) {
                timestamp = statusList[num * 10 - 10].time;
            }
            const date = new Date(timestamp.replace(' ', 'T') + 'Z');

            let hours: number | string = date.getHours();
            let minutes: number | string = date.getMinutes();

            minutes = Math.ceil(minutes / 10) * 10;

            if (minutes === 60) {
                minutes = 0;
                hours = (hours + 1) % 24;
            }

            hours = String(hours).padStart(2, '0');
            minutes = String(minutes).padStart(2, '0');

            return `${hours}:${minutes}`;

        }

        return '--'

    };

    const itemColor=(val:number) => {
        if(val===1){
            return 'text-[#3AC79D]'
        }
        if(val===2 || val===3){
            return 'text-[#EEB826]'
        }
        return 'text-[#F55454]'
    }
    const itemBgColor=(val:number) => {
        if(val===1){
            return 'bg-[#3AC79D]'
        }
        if(val===2 || val===3){
            return 'bg-[#EEB826]'
        }
        return 'bg-[#F55454]'
    }

    useEffect(() => {

        const style = document.createElement('style');
        style.type = 'text/css';

        style.innerHTML = `
            .state-${modifyString(name).toLowerCase()}::before {
                background: linear-gradient(135deg, ${colorStyle.background} 20%, #35363A 30%, #35363A 100%);
            }
            .state-${modifyString(name).toLowerCase()} .state-all-light::after {
                background: linear-gradient(110deg, ${colorStyle.borderColor} 10%, #1E1F24 40%, #1E1F24 100%);
            }
        `;

        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, [name, colorStyle]);

    if (!statusList) {
        return <></>
    }


    return <div className={`max-w-[632px] w-full state-${modifyString(name).toLowerCase()} state-all `}>
        <div className={`bg-[#1E1F24] z-[100] p-[20px] rounded-[10px] state-all-light `}>
            <div className={`flex justify-between items-center`}>
                <div className={`flex items-center`}>
                    {icon}
                    <div className={`ml-[8px] text-white text-[18px] font-semibold`}>{name}</div>
                </div>
                <div
                    className={`${itemBgColor(hasConsecutiveZeros(statusList, 1))}  rounded-[4px] text-white px-[12px] py-[4px] font-semibold`}>
                    {((statusList.filter(item => item.status===1).length / statusList.length) * 100).toFixed(2)}%
                </div>
            </div>
            <div
                className={`bg-[#FFFFFF15] rounded-[20px] h-[24px] flex items-center px-[9px] w-[570px] w-520-636 w-360-556 w-auto-436 mt-[30px] ${statusList.length<60?'gap-[4px]':'gap-[3px]'} state-popover`}>
                {statusList.map((item, index) => (
                    <Popover key={item.time} placement="bottom" title={''} content={<div>
                        <div className={`font-semibold text-white`}>{UtxTime(item.time)}</div>
                        <div
                            className={`${itemColor(item.status)} font-normal`}>{StateItemText(item.status)}</div>
                    </div>}>
                        <div
                            className={`w-[8px] h-[16px] w-5px-636 w-3px-556 w-2px-436 ${itemBgColor(item.status)} rounded-[21px] `}></div>
                    </Popover>
                ))}
            </div>
            <div className={`flex justify-between text-[11px] mt-[8px] gap-14`}>
                {statusList.length < 60
                    ?
                    <div className={` flex justify-between text-[11px]`}
                         style={{width: `${(statusList.length * 2) > 100 ? 100 : statusList.length * 2}%`}}>
                        {statusList.length >= 49 && <span className={`text-[#FFFFFF55]`}>{hoursChange(49)}</span>}
                        {statusList.length >= 40 && <span className={`text-[#FFFFFF55]`}>{hoursChange(7)}</span>}
                        {statusList.length >= 30 && <span className={`text-[#FFFFFF55]`}>{hoursChange(2.7)}</span>}
                        {statusList.length >= 20 && <span className={`text-[#FFFFFF55]`}>{hoursChange(2)}</span>}
                        {statusList.length >= 10 && <span className={`text-[#FFFFFF55]`}>{hoursChange(1.4)}</span>}
                        {statusList.length >= 1.2 && <span className={`text-[#FFFFFF55]`}>{hoursChange(1.2)}</span>}
                        {statusList.length >= 50 && <span className={`text-[#FFFFFF55]`}>now</span>}
                    </div>
                    :
                    <div className={` flex justify-between text-[11px]`}
                         style={{width: `${(statusList.length * 2) > 100 ? 100 : statusList.length * 2}%`}}>
                        {statusList.length >= 1 && <span className={`text-[#FFFFFF55]`}>{hoursChange(1)}</span>}
                        {statusList.length >= 2 && <span className={`text-[#FFFFFF55]`}>{hoursChange(2)}</span>}
                        {statusList.length >= 3 && <span className={`text-[#FFFFFF55]`}>{hoursChange(3)}</span>}
                        {statusList.length >= 4 && <span className={`text-[#FFFFFF55]`}>{hoursChange(4)}</span>}
                        {statusList.length >= 5 && <span className={`text-[#FFFFFF55]`}>{hoursChange(5)}</span>}
                        {statusList.length >= 6 && <span className={`text-[#FFFFFF55]`}>{hoursChange(6)}</span>}
                        {statusList.length >= 50 && <span className={`text-[#FFFFFF55]`}>now</span>}
                    </div>}

                {statusList.length < 50 && <span className={`text-[#FFFFFF55]`}>now</span>}
            </div>

        </div>
    </div>
}